import { ConsultationResponse, ConsultationResponseAnswer } from 'types';

export const MOCK_RPC_PAST_RESPONSE_SUMMARY_CONTENT =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tincidunt rutrum rhoncus.';

export const MOCK_RPC_RESPONSE_ANSWERS: ConsultationResponseAnswer[] = [
  {
    id: 1,
    consulteeId: 1,
    consulteeName: 'Bill Zuma',
    questionNumber: 1,
    question: 'Are there any proposals for road works which may affect the property?',
    answer: 'My answer 1',
    dateCreated: new Date('2022-02-02'),
    dateModified: new Date('2022-02-02'),
    organisation: {
      id: 1,
    },
  } as ConsultationResponseAnswer,
  {
    id: 2,
    consulteeId: 1,
    consulteeName: 'Bill Zuma',
    questionNumber: 2,
    question: 'Is the road adjoining the property maintainable by?',
    answer: 'My answer 2',
    dateCreated: new Date('2022-02-02'),
    dateModified: new Date('2022-02-02'),
    organisation: {
      id: 1,
    },
  } as ConsultationResponseAnswer,
];

export const MOCK_RPC_PAST_RESPONSE_ANSWERS: ConsultationResponseAnswer[] = [
  {
    ...MOCK_RPC_RESPONSE_ANSWERS[0],
    answer: 'My past answer 1',
  },
  {
    ...MOCK_RPC_RESPONSE_ANSWERS[1],
    answer: 'My past answer 2',
  },
  {
    ...MOCK_RPC_RESPONSE_ANSWERS[0],
    consulteeId: 2,
    consulteeName: 'Other consultee',
    answer: 'Other past answer 1',
  },
  {
    ...MOCK_RPC_RESPONSE_ANSWERS[1],
    consulteeId: 2,
    consulteeName: 'Other consultee',
    answer: 'Other past answer 2',
  },
];

export const MOCK_RPC_OTHER_RESPONSE_ANSWERS: ConsultationResponseAnswer[] = [
  {
    ...MOCK_RPC_RESPONSE_ANSWERS[0],
    answer: 'Other past answer 1',
    consulteeId: 3,
    consulteeName: 'Other organisation consultee',
    organisation: { id: 2 },
  } as ConsultationResponseAnswer,
  {
    ...MOCK_RPC_RESPONSE_ANSWERS[1],
    answer: 'Other past answer 2',
    consulteeId: 3,
    consulteeName: 'Other organisation consultee',
    organisation: { id: 2 },
  } as ConsultationResponseAnswer,
];

export const MOCK_RPC_RESPONSE: ConsultationResponse = {
  id: 1,
  consultationId: 2,
  consulteeId: 1,
  response: 'Test response',
  responseTypeId: 1,
  responseType: 'RPC',
  dateCreated: new Date('2022-02-02'),
  referenceNumber: 'CHR-1',
  documents: [],
  answers: MOCK_RPC_RESPONSE_ANSWERS,
};

export const MOCK_RPC_PAST_RESPONSE: ConsultationResponse = {
  ...MOCK_RPC_RESPONSE,
  id: 2,
  referenceNumber: 'CHR-2',
  submittedDate: new Date('2022-02-02'),
  answers: MOCK_RPC_PAST_RESPONSE_ANSWERS,
};

export const MOCK_RPC_OTHER_ORGANISATION_RESPONSE: ConsultationResponse = {
  ...MOCK_RPC_RESPONSE,
  id: 3,
  referenceNumber: 'CHR-3',
  submittedDate: new Date('2022-02-02'),
  answers: MOCK_RPC_OTHER_RESPONSE_ANSWERS,
};

export const MOCK_RPC_RESPONSES = [
  MOCK_RPC_RESPONSE,
  MOCK_RPC_PAST_RESPONSE,
  MOCK_RPC_OTHER_ORGANISATION_RESPONSE,
];
